import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AvailibleEquipment } from '../../../shared/interfaces/account.interfaces';

const basePath = '/account/equipment';

@Injectable({
  providedIn: 'root',
})

export class AccountEquipmentService {
  constructor(private http: HttpClient) { }

  // Get all equipments not linked to any account for a given dealer
  getAvailableEquipments(dealerId: number): Observable<AvailibleEquipment[] | []> {
    return this.http.get<AvailibleEquipment[] | []>(`${basePath}/all/${dealerId}`);
  }

  // Links an equipment to an account
  linkEquipmentToAccount(accountId: number | undefined, equipmentId: number | undefined) {
    const body = {
      accountId,
      equipmentId
    };
    return this.http.post(`${basePath}`, body);
  }

  // Unlinks an equipment from an account
  removeEquipmentFromAccount(accountId: number | undefined, equipmentId: number | undefined) {
    const body = {
      accountId,
      equipmentId
    };
    return this.http.delete(`${basePath}`, { body });
  }

}
